import { Partner } from '@medprev-web-app/api-graphql-client';

import { formatToTitleCase } from '@/utils/formatters/format-to-title-case';

export const resolvePartnerName = (partner: Partner): string => {
  const { socialName, legalName } = partner;

  if (socialName) {
    return formatToTitleCase(socialName);
  }

  return formatToTitleCase(legalName as string);
};
